// extracted by mini-css-extract-plugin
module.exports = {"contact":"styles_contact__2C-KL","references":"styles_references__BG3MK","intro":"styles_intro__3Dor_","companies":"styles_companies__3TjU5","holder":"styles_holder__2D3ZI"};